import React from 'react';
import { classNames } from '../../Services/helpers';

const ButtonRow = ({children, arrange = 'right', className}) => {
    const arrangements = {
        'right': 'justify-end',
        'left': 'justify-start',
        'around': 'justify-around',
        'center': 'justify-center',
        'between': 'justify-between',
        'betweenAround': 'justify-between md:justify-around',
    }
    return <div className={classNames('flex flex-wrap gap-x-3', arrangements[arrange] ?? 'justify-end', className)}>
        {children}
    </div>
}

export default ButtonRow;
